<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="750">
            <v-card flat>
                <v-card-title>
                    {{ $t('exchange_rate_display') }}
                    <v-spacer></v-spacer>
                    <v-menu
                        v-if="!loading.data"
                        offset-y>
                        <template v-slot:activator="{on}">
                            <v-btn
                                icon
                                v-on="on"
                                class="mx-1">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list width="250" dense>
                            <v-list-item
                                @click="openExchangeRate({ editMode: true, id: exchangeRate.id })"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-pencil</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('edit_exchange_rate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="openDeleteSingleDialog({target: 'exchangeRate', id: exchangeRate.id})"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('delete_exchange_rate') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-if="exchangeRate && !loading.data">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{ $t('date') }}</th>
                                <td>{{ exchangeRate.date }}</td>
                                <th>{{ $t('company') }}</th>
                                <td>{{ exchangeRate.company_name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('base_currency') }}</th>
                                <td>{{ exchangeRate.base_currency }}</td>
                                <th></th>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                     <v-data-table
                        class="mt-5"
                        dense
                        hide-default-footer
                        disable-pagination
                        :headers="headers.exchangeRates"
                        :items="exchangeRate.exchange_rate_lines">
                            <template v-slot:[`item.name`]="{ item }">
                            {{ `1 `+item.abbreviation+`` }}
                        </template>
                        <template v-slot:[`item.rate`]="{ item }">
                            {{ item.rate+` `+exchangeRate.base_currency }}
                        </template>

                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ExchangeRateDialog
            v-if="exchangeRateDialogProps.display"
            :id="exchangeRateDialogProps.id"
            @close="closeExchangeRate"
            @submit="createdDataFetch"
            ref="exchangeRateDialog"/>
        <DeleteSingleDialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
    </div>
</template>
<script>
import ExchangeRateDialog from '@/components/accounting/ExchangeRateDialog';
import DeleteSingleDialog from '@/components/common/DeleteSingleDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "ExchangeRateDisplayDialog",
    components: {
        ExchangeRateDialog,
        DeleteSingleDialog
    },
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            display: true,
            loading: {
                data: false
            },
            headers: {
                exchangeRates: [
                    { text: this.$t('currency'), value: 'name' },
                    { text: this.$t('rate'), value: 'rate' },
                ]
            },
            exchangeRateDialogProps: {
                display: false,
                id: null
            },
            
        }
    },
    computed: {
        ...mapState('accounting/exchangeRate', ["exchangeRate"]),
    },
    methods: {
        ...mapActions('accounting/exchangeRate', ["fetchExchangeRate", "removeExchangeRate"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                await this.fetchExchangeRate(this.id);
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        close() {
            this.$emit('close');
        },
        openExchangeRate({ editMode, id }) {
            editMode ? this.exchangeRateDialogProps.id = id : this.exchangeRateDialogProps.id = null;
            this.exchangeRateDialogProps.display = true;
        },
        closeExchangeRate(){
            this.exchangeRateDialogProps.display = false;
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'exchangeRate') {
                this.removeExchangeRate(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.createdDataFetch();
                        this.close();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
            this.selected.exchangeRates = [];
        },
    },
    created () {
        this.createdDataFetch();
    },
}
</script>